<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="`Sales Order # ${baseView.id}`"
        :secondaryLabel="customerName"
        v-if="loaded"
      />
    </template>

    <div class="summary-items" v-if="gaugeDataLoaded">
      <GcGauge
        gaugeTitle="Revenue"
        :originalValue="revenueGauge.originalValue"
        :originalValueFormat="revenueGauge.originalValueFormat"
        :actualValue="revenueGauge.actualValue"
        :actualValueFormat="revenueGauge.actualValueFormat"
        :leftGaugeValue="revenueGauge.leftGaugeValue"
        :leftGaugeValueFormat="revenueGauge.leftGaugeValueFormat"
        :rightGaugeValue="revenueGauge.rightGaugeValue"
        :rightGaugeValueFormat="revenueGauge.rightGaugeValueFormat"
        :leftGaugeBad="revenueGauge.leftGaugeBad"
        :rightGaugeBad="revenueGauge.rightGaugeBad"
      ></GcGauge>

      <GcGauge
        gaugeTitle="Cost"
        :originalValue="costGauge.originalValue"
        :originalValueFormat="costGauge.originalValueFormat"
        :actualValue="costGauge.actualValue"
        :actualValueFormat="costGauge.actualValueFormat"
        :leftGaugeValue="costGauge.leftGaugeValue"
        :leftGaugeValueFormat="costGauge.leftGaugeValueFormat"
        :rightGaugeValue="costGauge.rightGaugeValue"
        :rightGaugeValueFormat="costGauge.rightGaugeValueFormat"
        :leftGaugeBad="costGauge.leftGaugeBad"
        :rightGaugeBad="costGauge.rightGaugeBad"
      ></GcGauge>

      <GcGauge
        gaugeTitle="Gross Profit"
        :originalValue="grossProfitGauge.originalValue"
        :originalValueFormat="grossProfitGauge.originalValueFormat"
        :actualValue="grossProfitGauge.actualValue"
        :actualValueFormat="grossProfitGauge.actualValueFormat"
        :leftGaugeValue="grossProfitGauge.leftGaugeValue"
        :leftGaugeValueFormat="grossProfitGauge.leftGaugeValueFormat"
        :rightGaugeValue="grossProfitGauge.rightGaugeValue"
        :rightGaugeValueFormat="grossProfitGauge.rightGaugeValueFormat"
        :leftGaugeBad="grossProfitGauge.leftGaugeBad"
        :rightGaugeBad="grossProfitGauge.rightGaugeBad"
      ></GcGauge>

      <GcGauge
        gaugeTitle="Gross Profit %"
        :originalValue="grossMarginGauge.originalValue"
        :originalValueFormat="grossMarginGauge.originalValueFormat"
        :actualValue="grossMarginGauge.actualValue"
        :actualValueFormat="grossMarginGauge.actualValueFormat"
        :rightGaugeValue="grossMarginGauge.rightGaugeValue"
        :rightGaugeValueFormat="grossMarginGauge.rightGaugeValueFormat"
        :rightGaugeBad="grossMarginGauge.rightGaugeBad"
      >
      </GcGauge>
    </div>

    <div class="grid-area">
      <div class="css-v2 transaction-list no-pad max-width-1920">
        <gc-data-grid
          v-if="loaded"
          :rowClick="navigateToQuoteDetail"
          :gridToolbar="screenConfigQuoteSummary.gridData.toolbar"
          :id="'quote-summary-grid'"
          :dataSourceConfig="
            screenConfigQuoteSummary.gridData.gridOptions.dataSource
          "
          :columns="screenConfigQuoteSummary.gridData.columns"
          :isLocalDataSource="true"
          :gridHeightOverWrite="quoteGridHeight"
          :gridOptions="screenConfigQuoteSummary.gridData.gridOptions"
          :toolbarHeader="{
            primary: quoteHeader,
            secondary: null,
          }"
          ref="quoteSummary"
          :paging="false"
        >
        </gc-data-grid>
      </div>

      <div class="css-v2 transaction-list pad5 max-width-1920">
        <gc-data-grid
          v-if="loaded"
          :rowClick="navigateToPurchaseOrderDetail"
          :gridToolbar="screenConfigPurchaseOrder.gridData.toolbar"
          :id="'purchase-order-grid'"
          :dataSourceConfig="
            screenConfigPurchaseOrder.gridData.gridOptions.dataSource
          "
          :columns="screenConfigPurchaseOrder.gridData.columns"
          :gridHeightOverWrite="purchaseGridHeight"
          :gridOptions="screenConfigPurchaseOrder.gridData.gridOptions"
          :isLocalDataSource="true"
          :toolbarHeader="{
            primary: purchaseOrderHeader,
            secondary: null,
          }"
          ref="purchaseOrderSummary"
          :paging="false"
        >
        </gc-data-grid>
      </div>

      <div class="css-v2 transaction-list pad-10-b max-width-1920">
        <gc-data-grid
          v-if="loaded"
          :rowClick="navigateToWorkOrderDetail"
          :gridToolbar="screenConfigWorkOrder.gridData.toolbar"
          :id="'work-order-grid'"
          :dataSourceConfig="
            screenConfigWorkOrder.gridData.gridOptions.dataSource
          "
          :columns="screenConfigWorkOrder.gridData.columns"
          :gridHeightOverWrite="workOrderGridHeight"
          :gridOptions="screenConfigWorkOrder.gridData.gridOptions"
          :isLocalDataSource="true"
          :toolbarHeader="{
            primary: workOrderHeader,
            secondary: null,
          }"
          ref="workOrderSummary"
          :paging="false"
        >
        </gc-data-grid>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "../../_mixins/route.mixin";
import GcBaseLayout from "../../layouts/gc-base-layout.vue";
import GcGauge from "../../components/gc-gauge.vue";
import ApiService from "../../_services/api/api.service";
import { SalesOrderProfitEnquiryService } from "../../_services/api/sales/sales-order-profit-enquiry.service";

export default {
  mixins: [RouteMixin],
  data() {
    return {
      loaded: false,
      supplierName: "",
      customerName: "",
      quoteGridHeight: 332,
      purchaseGridHeight: 332,
      workOrderGridHeight: 332,
      readOnly: true,
      quoteHeader: "Quote Summary",
      purchaseOrderHeader: "Purchase Order Summary",
      workOrderHeader: "WO Summary",
      revenueGauge: {
        originalValue: undefined,
        originalValueFormat: "currency",
        actualValue: undefined,
        actualValueFormat: "currency",
        leftGaugeValue: undefined,
        leftGaugeValueFormat: "currency",
        rightGaugeValue: undefined,
        rightGaugeValueFormat: "percent",
        leftGaugeBad: false,
        rightGaugeBad: false,
      },
      costGauge: {
        originalValue: undefined,
        originalValueFormat: "currency",
        actualValue: undefined,
        actualValueFormat: "currency",
        leftGaugeValue: undefined,
        leftGaugeValueFormat: "currency",
        rightGaugeValue: undefined,
        rightGaugeValueFormat: "percent",
        leftGaugeBad: false,
        rightGaugeBad: false,
      },
      grossProfitGauge: {
        originalValue: undefined,
        originalValueFormat: "currency",
        actualValue: undefined,
        actualValueFormat: "currency",
        leftGaugeValue: undefined,
        leftGaugeValueFormat: "currency",
        rightGaugeValue: undefined,
        rightGaugeValueFormat: "percent",
        leftGaugeBad: false,
        rightGaugeBad: false,
      },
      grossMarginGauge: {
        originalValue: undefined,
        originalValueFormat: "percent",
        actualValue: undefined,
        actualValueFormat: "percent",
        rightGaugeValue: undefined,
        rightGaugeValueFormat: "percent",
        rightGaugeBad: false,
      },
      salesQuoteSummaryData: [],
      salesOrderEnquiryPurchaseOrderData: [],
      workOrderSummaryData: [],
      gaugeDataLoaded: false,
    };
  },
  async created() {
    let screenData = [];
    let isQueryEmpty = Object.keys(this.baseView.query).length == 0;
    if (!isQueryEmpty) {
      screenData = this.baseView.query;
    } else {
      const requestScreenData = {
        url: "SalesOrderProfitEnquiryList",
        top: "1",
        filter: `SalesOrderCode eq ${this.baseView.id}`,
      };
      screenData = (await ApiService.oDataGet(requestScreenData)).data[0];
    }

    this.customerName = screenData.CustomerName;

    this.revenueGauge.originalValue = screenData.OriginalSalesAmountExTax;
    this.revenueGauge.actualValue = screenData.SalesAmountExTax;
    let revenueDifference =
      screenData.OriginalSalesAmountExTax - screenData.SalesAmountExTax;
    this.revenueGauge.leftGaugeValue = Math.abs(revenueDifference);
    if (screenData.OriginalSalesAmountExTax == 0) {
      this.revenueGauge.rightGaugeValue = Math.abs(revenueDifference / 1.0);
    } else {
      this.revenueGauge.rightGaugeValue = Math.abs(
        revenueDifference / screenData.OriginalSalesAmountExTax
      );
    }

    this.revenueGauge.leftGaugeBad = revenueDifference > 0;
    this.revenueGauge.rightGaugeBad = revenueDifference > 0;

    this.costGauge.originalValue = screenData.OriginalCost;
    this.costGauge.actualValue = screenData.ActualCost;
    let costDifference = screenData.OriginalCost - screenData.ActualCost;
    this.costGauge.leftGaugeValue = Math.abs(costDifference);
    this.costGauge.rightGaugeValue = Math.abs(
      costDifference / screenData.OriginalCost
    );
    this.costGauge.leftGaugeBad = costDifference < 0;
    this.costGauge.rightGaugeBad = costDifference < 0;

    this.grossProfitGauge.originalValue = screenData.OriginalGrossProfit;
    this.grossProfitGauge.actualValue = screenData.ActualGrossProfit;
    let profitDifference =
      screenData.OriginalGrossProfit - screenData.ActualGrossProfit;
    this.grossProfitGauge.leftGaugeValue = Math.abs(profitDifference);
    this.grossProfitGauge.rightGaugeValue = Math.abs(
      profitDifference / screenData.OriginalGrossProfit
    );
    this.grossProfitGauge.leftGaugeBad = profitDifference > 0;
    this.grossProfitGauge.rightGaugeBad = profitDifference > 0;

    this.grossMarginGauge.originalValue = screenData.OriginalMarginPct / 100;
    this.grossMarginGauge.actualValue = screenData.ActualMarginPct / 100;
    let grossMarginDifference =
      screenData.OriginalMarginPct - screenData.ActualMarginPct;
    this.grossMarginGauge.rightGaugeValue = Math.abs(
      grossMarginDifference / 100
    );
    this.grossMarginGauge.rightGaugeBad = grossMarginDifference > 0;

    this.gaugeDataLoaded = true;

    this.salesQuoteSummaryData = await SalesOrderProfitEnquiryService.getQuoteSummaryForSalesOrderCode(
      this.baseView.id
    );
    this.salesQuoteSummaryData.forEach((row) => {
      row["ComputedSalesQuoteCode"] = `${row.SalesQuoteCode}`;
    });

    this.salesOrderEnquiryPurchaseOrderData = await SalesOrderProfitEnquiryService.getPurchaseOrderSummaryForSalesOrderCode(
      this.baseView.id
    );
    this.salesOrderEnquiryPurchaseOrderData.forEach((row) => {
      row["ComputedPurchaseOrderCode"] = `${row.Code}`;
      row["Variance"] = row.PurchaseAmount - row.InvoicedAmount;
    });

    this.workOrderSummaryData = await SalesOrderProfitEnquiryService.getWorkOrderSummaryForSalesOrderCode(
      this.baseView.id
    );
    this.workOrderSummaryData.forEach((row) => {
      row["ComputedWorkOrderCode"] = `${row.WorkOrderCode}`;
      row["Variance"] = row.ActualGrossProfit - row.OriginalGrossProfit;
    });

    this.loaded = true;
  },
  components: { GcBaseLayout, GcGauge },
  computed: {
    getScreenJson() {
      return {
        title: "Sales Order Enquiry",
      };
    },
    screenConfigQuoteSummary() {
      var config = {
        gridData: {
          gridOptions: {
            dataSource: {
              serverPaging: false,
              allowGrouping: false,
              localDataList: true,
              items: this.salesQuoteSummaryData,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No data to display",
                message: `There are no sales quotes associated with the Sales Order # ${this.baseView.id}`,
                noImage: false,
                small: true,
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            header: true,
          },
          columns: [
            {
              screenField: "PurchaseOrder",
              dataField: "SalesQuoteCode",
              gridDataField: "ComputedSalesQuoteCode",
              label: "Quote #",
              minWidth: 120,
              width: 120,
            },
            {
              screenField: "RequiredDate",
              dataField: "QuoteDate",
              label: "Quote Date",
              minWidth: 150,
              width: 150,
            },
            {
              screenField: "RequiredDate",
              dataField: "ShipDate",
              label: "Ship Date",
              minWidth: 150,
              width: 150,
            },
            {
              dataField: "RepName",
              label: "Rep",
            },
            {
              screenField: "STDCostTotal",
              dataField: "STDCostTotal",
              label: "STD Cost",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "ListPriceTotal",
              dataField: "ListPriceTotal",
              label: "List Total",
              format: "Decimal-16-2",
              minWidth: 150,
              width: 150,
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Quantity",
              dataField: "DiscPcnt",
              label: "Disc %",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2P",
              allowSearch: false,
            },
            {
              screenField: "NetPriceTotal",
              dataField: "NetPriceTotal",
              label: "Net Total",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Quantity",
              dataField: "GPPcnt",
              label: "GP %",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2P",
              allowSearch: false,
            },
            {
              screenField: "Status",
              cellTemplate: "Status",
              dataField: "Status",
              label: "",
              allowSearch: false,
            },
          ],
        },
      };
      return config;
    },
    screenConfigPurchaseOrder() {
      var config = {
        gridData: {
          gridOptions: {
            dataSource: {
              serverPaging: false,
              allowGrouping: false,
              localDataList: true,
              items: this.salesOrderEnquiryPurchaseOrderData,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No data to display",
                message: `There are no purchase orders associated with the Sales Order # ${this.baseView.id}`,
                small: true,
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            header: true,
          },
          columns: [
            {
              dataField: "Code",
              gridDataField: "ComputedPurchaseOrderCode",
              label: "PO #",
              minWidth: 100,
              width: 100,
              sortOrder: "desc",
              sortIndex: 0,
            },
            {
              screenField: "Supplier",
              dataField: "SupplierName",
              allowSearch: true,
              gridDataField: "SupplierName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
            },
            {
              screenField: "RequiredDate",
              dataField: "DateCreated",
              label: "Date Created",
              minWidth: 150,
              width: 150,
            },
            {
              dataField: "CreatedBy",
              label: "Raised By",
              minWidth: 150,
              width: 150,
            },
            {
              screenField: "PurchaseAmount",
              dataField: "PurchaseAmount",
              label: "PO Ex Tax",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "InvoicedAmount",
              dataField: "InvoicedAmount",
              label: "Invoice Ex Tax",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Variance",
              dataField: "Variance",
              label: "Variance Ex Tax",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Status",
              cellTemplate: "Status",
              dataField: "PurchaseOrderStatus",
              label: "",
              fixed: false,
              allowSearch: false,
            },
            {
              screenField: "Status",
              cellTemplate: "Status",
              dataField: "InvoicedStatus",
              label: "",
              fixed: false,
              allowSearch: false,
            },
          ],
        },
      };

      return config;
    },
    screenConfigWorkOrder() {
      var config = {
        gridData: {
          gridOptions: {
            dataSource: {
              serverPaging: false,
              allowGrouping: false,
              localDataList: true,
              items: this.workOrderSummaryData,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No data to display",
                message: `There are no work orders associated with the Sales Order # ${this.baseView.id}`,
                small: true,
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            header: true,
          },
          columns: [
            {
              screenField: "PurchaseOrder",
              dataField: "WorkOrderCode",
              gridDataField: "ComputedWorkOrderCode",
              label: "WO #",
              minWidth: 110,
              width: 110,
              sortOrder: "desc",
              sortIndex: 0,
            },
            {
              dataField: "BOMName",
              label: "BOM",
            },
            {
              screenField: "SalesAmountExTax",
              dataField: "SalesAmountExTax",
              label: "Sales Amount Ex Tax $",
              minWidth: 100,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "OriginalCost",
              dataField: "OriginalCost",
              label: "Original Cost",
              minWidth: 100,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "ActualCost",
              dataField: "ActualCost",
              label: "Actual Cost",
              minWidth: 100,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "OriginalGrossProfit",
              dataField: "OriginalGrossProfit",
              label: "Original GP",
              minWidth: 100,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Quantity",
              dataField: "OriginalMarginPct",
              label: "Original GP %",
              minWidth: 100,
              format: "Decimal-16-2P",
              allowSearch: false,
            },
            {
              screenField: "ActualGrossProfit",
              dataField: "ActualGrossProfit",
              label: "Actual GP",
              minWidth: 100,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
            {
              screenField: "Quantity",
              dataField: "ActualMarginPct",
              label: "Actual GP %",
              minWidth: 100,
              format: "Decimal-16-2P",
              allowSearch: false,
            },
            {
              screenField: "Status",
              cellTemplate: "Status",
              dataField: "WorkOrderStatus",
              label: "",
              allowSearch: false,
            },
            {
              screenField: "Variance",
              dataField: "Variance",
              label: "Variance",
              minWidth: 150,
              width: 150,
              format: "Decimal-16-2",
              allowSearch: false,
              grandTotal: "SUM",
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    backButtonRoute() {
      return "/sales-order-profit-enquiry";
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute(),
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    navigateToQuoteDetail(e) {
      let salesQuote = e.data.SalesQuoteCode;
      var newTab = this.$router.resolve({
        path: `/sales-quote/review/${salesQuote}`,
        query: e.data,
      });
      window.open(newTab.href, "_blank");
    },
    navigateToPurchaseOrderDetail(e) {
      let purchaseOrderCode = e.data.Code;
      var newTab = this.$router.resolve({
        path: `/purchase-order/review/${purchaseOrderCode}`,
      });
      window.open(newTab.href, "_blank");
    },
    navigateToWorkOrderDetail(e) {
      let workOrderCode = e.data.WorkOrderCode;
      var newTab = this.$router.resolve({
        path: `/work-order/review/${workOrderCode}`,
        query: e.data,
      });
      window.open(newTab.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
.grid-area {
  align-content: center;
  text-align: center;
  align-items: center;
}

.dx-datagrid-header-panel {
  border-radius: 5px;
  padding-top: 0px;
}

.no-pad {
  padding-right: 10px !important;
  padding-left: 10px !important;
  padding-bottom: 5px !important;
  padding-top: 0px !important;
}

.pad5 {
  padding-top: 5px !important;
  padding-right: 10px !important;
  padding-left: 10px !important;
  padding-bottom: 5px !important;
}

.pad-10-b {
  padding-bottom: 10px !important;
}

.dx-datagrid {
  border-radius: 5px;
}

.gc-data-grid {
  border-radius: 5px;
}

.summary-items {
  align-content: center;
  display: flex;
  justify-content: center;
  top: 0;
  max-width: 1920px;
  position: relative;
  margin: 0 auto;
}

.max-width-1920 {
  max-width: 1920px;
  position: relative;
  margin: 0 auto;
}
</style>
